<div class="tab-pane" id="tab-nrt" role="tabpanel" aria-labelledby="tab-nrt-tab">
    Atualiza arquivo
    <div>
        <div style="display: flex; justify-content: space-around;">
            <div class="all-center">
                <button type="button" mat-raised-button color="primary" (click)="fileInput.click()">Selecionar arquivo</button>
                <input hidden (change)="onFileChange($event)" #fileInput type="file" id="file">
                {{fileName}}
            </div>
        </div>

        <!-- <div class="element-inline">
            <mat-form-field class="mb-3">
                <mat-label>Nome arquivo</mat-label>
                <input autocomplete="off" matInput [formControl]="form.get('nomeArquivo')">
                <mat-hint align="start">Obrigatório</mat-hint>
            </mat-form-field>
        </div> -->

        <div style="display: flex; justify-content: space-around; margin-top: 20px;">
            <button type="button" mat-raised-button color="primary" [disabled]="files == 0" (click)="uploadImage()">Salvar</button>
            <button type="button" mat-raised-button color="warn" (click)="dialogRef.close()">Fechar</button>
        </div>
    </div>
</div>